import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'Ogólne',
    [Tab.SignedLive]: 'Podpisani / Na żywo',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Prowizja',
  },
};
